/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Card_UnpaidInputs */

const en_admin_funnel_card_unpaid = /** @type {(inputs: Admin_Funnel_Card_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkout, unpaid (24h)`)
};

/**
* | output |
* | --- |
* | "Checkout, unpaid (24h)" |
*
* @param {Admin_Funnel_Card_UnpaidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_card_unpaid = /** @type {((inputs?: Admin_Funnel_Card_UnpaidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Card_UnpaidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_card_unpaid(inputs)
});
export { admin_funnel_card_unpaid as "admin.funnel.card.unpaid" }